import {
  type TimekeepingCredentialVariant,
  type WorkplaceProfileResponse,
} from "@clipboard-health/contract-backend-main";
import {
  type ExtendedExternalIntegrationType,
  ExtendedExternalIntegrationTypes,
} from "@src/appV2/ExternalIntegrations/types";

interface CredentialVariantInfo {
  variant: TimekeepingCredentialVariant | undefined;
  timeclockComplianceType: ExtendedExternalIntegrationType;
}

export function getCredentialVariant(
  workplaceProfile: WorkplaceProfileResponse | undefined
): CredentialVariantInfo {
  const variant =
    workplaceProfile?.data.attributes.workerCredentialConfiguration?.timekeeping.credentialVariant;
  const resolvedVariant = variant === "UNRECOGNIZED_" ? undefined : variant;

  const timeclockComplianceType =
    resolvedVariant === "pin-plus-password"
      ? ExtendedExternalIntegrationTypes.TIMECLOCK_COMPLIANCE_PIN_PLUS_PASSWORD
      : ExtendedExternalIntegrationTypes.TIMECLOCK_COMPLIANCE;

  return { variant: resolvedVariant, timeclockComplianceType };
}
